<template>
  <ConfigErrorBoundary>
    <FileConverter
      :config="converterConfig"
      @batch-created="handleBatchCreated"
      @job-completed="handleJobCompleted"
      @batch-cleared="handleBatchCleared"
      @error="handleError"
      @credits-updated="handleCreditsUpdated"
    />
  </ConfigErrorBoundary>
</template>

<script setup lang="ts">
import FileConverter from './FileConverter.vue';
import ConfigErrorBoundary from './ConfigErrorBoundary.vue';
import { parseAndValidateConverterConfig } from '../utils/ConfigValidator';

const converterConfig = parseAndValidateConverterConfig('zip-to-tar-gz-converter', 'ZIP to TAR.GZ');

function handleBatchCreated(batchId: string) {
  console.log('[ZIP to TAR.GZ Converter] Batch created:', batchId);
}

function handleJobCompleted(jobId: string) {
  console.log('[ZIP to TAR.GZ Converter] Job completed:', jobId);
}

function handleBatchCleared() {
  console.log('[ZIP to TAR.GZ Converter] Batch cleared');
}

function handleError(error: Error) {
  console.error('[ZIP to TAR.GZ Converter] Error:', error);
}

function handleCreditsUpdated(credits: number) {
  console.log('[ZIP to TAR.GZ Converter] Credits updated:', credits);
}
</script>
